var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper",attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":"searchQuestion,allQuestion,smSearch,smDetail"}},[_c('router-view',{staticClass:"page-view"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }